var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_340_32937)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 13.3359C29.3629 13.3359 26.7851 14.1179 24.5924 15.583C22.3997 17.0481 20.6908 19.1305 19.6816 21.5668C18.6724 24.0032 18.4084 26.6841 18.9229 29.2705C19.4373 31.8569 20.7072 34.2327 22.5719 36.0974C24.4366 37.9621 26.8124 39.2319 29.3988 39.7464C31.9852 40.2609 34.6661 39.9968 37.1024 38.9877C39.5388 37.9785 41.6212 36.2695 43.0863 34.0769C44.5513 31.8842 45.3333 29.3064 45.3333 26.6693C45.3333 23.1331 43.9286 19.7417 41.4281 17.2412C38.9276 14.7407 35.5362 13.3359 32 13.3359ZM32 34.6693C30.4177 34.6693 28.871 34.2001 27.5554 33.321C26.2398 32.442 25.2145 31.1925 24.609 29.7307C24.0035 28.2689 23.845 26.6604 24.1537 25.1085C24.4624 23.5567 25.2243 22.1312 26.3431 21.0124C27.462 19.8936 28.8874 19.1317 30.4393 18.823C31.9911 18.5143 33.5997 18.6727 35.0615 19.2782C36.5233 19.8837 37.7727 20.9091 38.6518 22.2247C39.5308 23.5403 40 25.087 40 26.6693C40 28.791 39.1571 30.8258 37.6569 32.3261C36.1566 33.8264 34.1217 34.6693 32 34.6693ZM56 64.0026V61.3359C56 56.3852 54.0333 51.6373 50.5327 48.1366C47.032 44.6359 42.284 42.6693 37.3333 42.6693H26.6667C21.716 42.6693 16.968 44.6359 13.4673 48.1366C9.96666 51.6373 8 56.3852 8 61.3359V64.0026H13.3333V61.3359C13.3333 57.7997 14.7381 54.4083 17.2386 51.9078C19.7391 49.4074 23.1304 48.0026 26.6667 48.0026H37.3333C40.8696 48.0026 44.2609 49.4074 46.7614 51.9078C49.2619 54.4083 50.6667 57.7997 50.6667 61.3359V64.0026H56Z",
    fill: "#D1D5DB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_340_32937"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/Avatar.7e15ebcca8030ca62cde79c86243c624.svg";
export { ForwardRef as ReactComponent };